import React from 'react';
import { LucideIcon } from 'lucide-react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
}

interface StatCardProps {
  title: string;
  value: string;
  icon: LucideIcon;
  iconColor?: string;
  iconBgColor?: string;
}

interface ChartCardProps {
  title: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

export function Card({ children, className = '' }: CardProps) {
  return (
    <div className={`bg-slate-900/40 backdrop-blur-lg border border-white/10 rounded-xl ${className}`}>
      {children}
    </div>
  );
}

export function StatCard({ 
  title, 
  value, 
  icon: Icon,
  iconColor = 'text-blue-400',
  iconBgColor = 'bg-blue-600/20'
}: StatCardProps) {
  return (
    <Card className="p-4">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs text-white/60">{title}</p>
          <p className="text-2xl font-semibold">{value}</p>
        </div>
        <div className={`h-10 w-10 ${iconBgColor} rounded-lg flex items-center justify-center`}>
          <Icon className={`h-5 w-5 ${iconColor}`} />
        </div>
      </div>
    </Card>
  );
}

export function ChartCard({ title, children, actions, className = '' }: ChartCardProps) {
  return (
    <Card className={`p-6 ${className}`}>
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-medium">{title}</h2>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
      {children}
    </Card>
  );
}